import React, { Component } from 'react';
import './../../assets/css/App.css';
import maskLoaderImg from './../../assets/images/loader.gif';
import Service from './service';
import Table from './../../component/table/table/Table';
import TableRowColumn from './../../component/table/table/TableRowColumn';
import TableHead from './../../component/table/table/TableHead';
import TableHeaderColumn from './../../component/table/table/TableHeaderColumn';
import TableBody from './../../component/table/table/TableBody';
import TableSearchHeader from './../../component/table/table/TableSearchHeader';
import TablePagination from './../../component/table/pagination';
import Utils from './../../component/utils/utils';
import DatePicker from './../../component/datePicker';
import AccountViewTypeEnum from './AccountViewTypeEnum';

class TableView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        tableHeaderTitle: "Accounts without sent shipments",
        pagingMetadata: [],
        responseTableData: {},
        showMask: false
    }

    constructor() {
        super();
        // setting default attribute values
        this.currentPage = 0;
        this.searchFieldValuesObject = {};
        this.createdDateStart = "";
        this.createdDateEnd = "";
        this.viewType = AccountViewTypeEnum.AccountWithoutSentShipment;
    }

    componentDidMount () {
        Service.event.onAccountsWithoutSendShipment.add((data) => {
            this.setState({
                responseTableData: data,
                pagingMetadata: data.pagingMetadata
            });
        });
    }
    // private
    _callServiceFetch(page) {
        this.setState({
            showMask: true
        });

        var searchParams = {};
        searchParams.createdDateStart = this.createdDateStart;
        searchParams.createdDateEnd = this.createdDateEnd;
        Service.fetchCannedAccountReport(page, searchParams, this.viewType).finally(() => {
            this.setState({ showMask: false });
        });
    }

    // private
    _callServiceDownloadFile() {
        var searchParams = {};
        searchParams.createdDateStart = this.createdDateStart;
        searchParams.createdDateEnd = this.createdDateEnd;
        Service.downloadCannedAccountReport(searchParams, this.viewType);
    }

    onStartDateFieldChange = (value) => {
        this.createdDateStart = value;
    };

    onEndDateFieldChange = (value) => {
        this.createdDateEnd = value;
    };

    // table actions
    searchButtonAction = () => {
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToPage = (e) => {
        e.preventDefault();
        var page = e.currentTarget.attributes.getNamedItem('data-page').value;
        this.currentPage = Number(page);
        this._callServiceFetch(page);
    };

    goForwardToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 0) {
            this.currentPage = this.currentPage + 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    goBackToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    jumpToFirstPage = (e) => {
        e.preventDefault();
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToLastPage = (e) => {
        e.preventDefault();
        this.currentPage = Number(this.state.pagingMetadata.pageCount);
        this._callServiceFetch(this.currentPage);
    };

    downloadFileAction = () => {
        this._callServiceDownloadFile();
    };

    createTableRowColumns = () => {
        var rowColumnComponentList = [];
        if (this.state.responseTableData.results !== undefined) {
            if (this.state.showMask) {
                rowColumnComponentList.push(<tr key="1"><td colSpan="8"><img src={maskLoaderImg} className="centerSpinnerImage"/></td></tr>);
            } else {
                rowColumnComponentList = this.state.responseTableData.results.map(function (item, index) {
                    var rowColumnComponent = {};
                    rowColumnComponent = <tr key={index}>
                        <TableRowColumn>{item.accountId}</TableRowColumn>
                        <TableRowColumn>{item.lockerCode}</TableRowColumn>
                        <TableRowColumn>{item.firstName}</TableRowColumn>
                        <TableRowColumn>{item.lastName}</TableRowColumn>
                        <TableRowColumn>{item.countryName}</TableRowColumn>
                        <TableRowColumn>{item.accountRole}</TableRowColumn>
                        <TableRowColumn>{item.createdDate}</TableRowColumn>
                    </tr>
                    return rowColumnComponent;
                });
            }
        } else {
            if (this.state.showMask) {
                rowColumnComponentList.push(<tr key="1"><td colSpan="8"><img src={maskLoaderImg} className="centerSpinnerImage"/></td></tr>);
            } else {
                rowColumnComponentList.push(<tr key="0"><td colSpan="8">{this.state.emptyTableMessage}</td></tr>);
            }
        }
        return rowColumnComponentList;
    };

    render() {
        return (
            <div>
                <Table>
                    <TableSearchHeader
                        headerClassName = {"fa fa-credit-card"}
                        tableHeaderTitle = {this.state.tableHeaderTitle}
                        searchButtonAction = {this.searchButtonAction}
                        downloadFileAction = {this.downloadFileAction}
                        selectDropdownValues = {this.selectDropdownloIntervalValuesForThreeMonth}
                        type = "cannedReport"
                    >
                        <DatePicker
                            fieldId = "accountStartDatePicker"
                            placeHolderText = "Start Date"
                            onChange = {this.onStartDateFieldChange}
                            fieldType = "startDate"
                        ></DatePicker>
                        <DatePicker
                            fieldId = "accountEndDatePicker"
                            placeHolderText = "End Date"
                            onChange = {this.onEndDateFieldChange}
                            fieldType = "endDate"
                        ></DatePicker>
                    </TableSearchHeader>
                   <TableHead>
                       <tr>
                           <TableHeaderColumn>Account Id</TableHeaderColumn>
                           <TableHeaderColumn>Locker</TableHeaderColumn>
                           <TableHeaderColumn>First Name</TableHeaderColumn>
                           <TableHeaderColumn>Last Name</TableHeaderColumn>
                           <TableHeaderColumn>Country</TableHeaderColumn>
                           <TableHeaderColumn>Roles</TableHeaderColumn>
                           <TableHeaderColumn>Date Joined</TableHeaderColumn>
                       </tr>
                   </TableHead>
                   <TableBody>
                       {this.createTableRowColumns()}
                   </TableBody>
                    <TablePagination
                        pagingMetadata={this.state.pagingMetadata}
                        jumpToPage={this.jumpToPage}
                        goForwardToPage={this.goForwardToPage}
                        goBackToPage={this.goBackToPage}
                        jumpToFirstPage={this.jumpToFirstPage}
                        jumpToLastPage={this.jumpToLastPage}>
                    </TablePagination>
                </Table>
            </div>
        );
    }
}

export default TableView;